__turbopack_context__.v({
  "rotation": "Spinner-module-sass-module__jPCs2G__rotation",
  "spinner": "Spinner-module-sass-module__jPCs2G__spinner",
});
